import http from './http';

export default {
  // 获取时间戳
  getTimestamp: () => http.getTimestamp('/timestamp'),
  // 限流
  getLimitFlow: () => http.limitRequest(),
  // 获取用户详情
  // wx
  getUserData: params => http.mGet('/user/frontend/account/detail', params),
  // app
  getAppUserData: params => http.get('/v2/user/frontend/getUserDetail', params),
  // 分享有礼
  getShare: params => http.post('/campaign/frontend/share/award', params),
  // 获取产品详情
  newGetProductDetail: params => http.get('/v3/product/frontend/detail', params),

  // 登陆
  // mock
  loginMock: params => http.get('/login/mock', params),
  // 登陆
  login: params => http.get('/frontend/login', params),

  // 获取验证码
  getCode: params => http.post('/frontend/sms/send', params),
  // 注册
  accountBind: params => http.post('/user/frontend/account/bind', params),

  // 获取城市列表
  getCityList: params => http.get('/v3/chosen/frontend/cityList', params),
  // 获取精品推荐搜索名
  getKeyWords: () => http.get('/v3/home/frontend/keyWords'),

  // 会员中心
  // 获取开卡礼
  getOpenCard: () => http.post('/campaign/frontend/award/get/opencard'),
  // 获取生活轨迹
  getLocus: params => http.get('/v2/user/frontend/getLocus', params),

  // 我的卡卷
  // 获取卡卷列表
  getCouponList: params => http.get('/v3/coupon/frontend/list', params),
  // 获取卡卷详情
  getCouponDetail: params => http.get('/v3/coupon/frontend/detail', params),
  // 获取产品详情
  getProductDetail: params => http.get('/v2/pointExchange/frontend/getProductInfo', params),
  // 分享礼券
  shareCoupon: params => http.post('/coupon/frontend/send/coupon', params),

  // 兑换中心
  redeemCoupon: params => http.get('/v3/usercoupon/frontend/redeemCoupon', params),

  // 品牌特权
  // 获取用户等级
  getLevels: () => http.get('/v2/user/frontend/getLevels'),
  // 获取品牌特权
  getEntList: params => http.get('/v3/enterprise/frontend/entList', params),

  // 我的订单
  // 获取订单列表
  getOrderList: params => http.get('/v3/orders/frontend/orderList', params),

  /**
   * 网关订单列表
   * @param {Object} params
   * status - 0：未支付 1：已取消 2：已支付 3：已过期 4:退款中 5:已退款 6:已完成 7:转增中 8:已转赠 9:待评价
   * pageNum - 页码
   * pageSize - 页码大小
   * isReverse - 0: 正常查询 1: 反向查询 传0屏蔽动物园订单
   */
  getMApiOrderList: params => http.mPost('/order/app/order/findOrderMain/list', params),

  /**
   * 获取子订单列表
   * 传参同网关订单列表
   */
  getMapiSuborderList: params => http.mPost('/order/app/order/queryrefundSubOrder', params),

  /**
   * 网关订单详情
   * @param {Object} params
   * orderId - 订单id
   */
  getMapiOrderDetail: params => http.mPost('/order/app/order/new/queryMainOrder/info', params),

  /**
   * 退款触发营销引擎
   * id - 订单id
   */
  checkMarketingEngine: id => http.mGet(`/order/app/pay/ubr/checkMarketingEngine/${id}`),

  /**
   * 获取UBR订单退款服务费
   * @param {Object} data
   * ids - String 子订单id 多个用逗号隔开
   */
  getUBRRefundServiceFee: data => http.mPost('/order/app/pay/ubr/getRefundServiceFee', data),

  /**
   * UBR子订单退款
   * @param {Object} data
   * ids - String 子订单id 多个用逗号隔开
   */
  ubrRefundOrder: data => http.mPost('/order/app/pay/ubr/refundOrder', data),

  // 获取当前订单是否已选择收货地址
  queryOrderHarvest: params => http.get('/v3/orders/frontend/queryOrderHarvest', params),
  // 支付订单
  payOrder: params => http.post('/v2/pay/makePreOrder', params),
  // 检查当前订单是否可以开具发票
  checkOrderInvoice: params => http.post('/sxf/frontend/isNeedDreceipt', params),
  // 获取发票二维码链接
  getInvoiceUrl: params => http.post('/sxf/frontend/qrCodeUrl', params),
  // 确认选择地址接口
  addOrderHarvest: params => http.post('/v3/orders/frontend/addOrderHarvest', params),
  // 获取订单详情
  getOrderDetail: params => http.get('/v3/orders/frontend/detail', params),
  // 取消订单
  cancelOrder: params => http.get('/v3/orders/frontend/cancelOrder', params),
  // 取消订单
  v2CancelOrder: params => http.post('/v2/orders/frontend/cancelOrder', params),
  // 重新预约
  reserveOrder: params => http.get('/v3/orders/frontend/reserve', params),
  // 申请退款
  applyRefund: params => http.post('/v3/orders/frontend/refundOrder', params),
  // 线下订单退款
  offlineApplyRefund: params => http.post('/v3/orders/frontend/applyRefundOrder', params),
  // 获取线下订单详情
  getOfflineData: params => http.get('/v3/orders/frontend/lineDetail', params),
  // 跳转线下支付
  goOfflinePay: params => http.get('/plugins/sxf/getUserEncryptData', params),
  // 物流信息
  getLogisticInfo: params => http.get('/v4/frontend/logistics/receiveMap', params),

  // 积分专区
  // 获取积分
  getPoint: params => http.get('/user/frontend/account/expirePoint', params),
  // 获取积分列表
  getUserPointList: params => http.post('/point/frontend/point', params),
  // 制作积分红包
  makePointPacket: params => http.post('/point/frontend/gift', params),
  // 获取拼手气列表
  getLuckList: params => http.get('/point/frontend/point/luck', params),
  // 领取积分
  getPointGift: params => http.get('/point/frontend/recipient/gift', params),
  
  // 开卡礼
  // 获取开卡礼详情
  getOpenCardDetail: (params) => http.get('/campaign/frontend/award/detail', params),
  // 获取开卡礼详情 APP
  getAppOpenCardDetail: (params) => http.get('/campaign/frontend/award/detail/app', params),
  // 领取开卡礼
  getAward: (params) => http.post('/campaign/frontend/award/get', params),
  // 领取开卡礼 App
  getAppAward: (params) => http.post('/campaign/frontend/award/get/app', params),

  // 分享卡卷
  // 领取礼券
  getCoupon: params => http.post('/coupon/frontend/get/coupon', params),
  // 获取卡券信息
  getCouponData: params => http.get('/common/frontend/coupon/detail', params),

  // 会员专区
  // 领取本月福利
  getWelfare: params => http.post('/v2/user/frontend/sendProduct', params),
  // 获取本月福利
  getBenefit: params => http.get('/v2/user/frontend/getBenefit', params),
  // 获取品牌特权
  getBrandPrivilege: params => http.get('/v3/enterprise/frontend/homeEnterprise', params),
  // 获取会员十大特权
  getTenPrivilege: params => http.post('/v3/privilege/frontend/privilegeList', params),

  // 会员日
  // 创建会员日
  createMemberDayApi: params => http.post('/v2/user/frontend/saveScenes', params),
  // 获取会员日列表
  memberDayList: params => http.get('/v2/user/frontend/memberdayList', params),
  // 获取会员日场景
  scenesList: () => http.get('/v2/user/frontend/scenesList'),

  // 获取会员任务列表
  getMissionList: () => http.get('/user/frontend/mission/list'),

  // 会员信息
  // 上传头像
  upLoadAvatar: params => http.post('/common/frontend/upload', params),
  // 提交信息
  userRegister: params => http.post('/user/frontend/account/register', params),
  // 选择喜欢操作 获取喜欢数据
  selectLikeSave: params => http.post('/tag/frontend/saveTags', params),
  /* // 车牌键盘确认操作
  confirmHandler: params => {
    return http.post('/user/frontend/account/register', params);
  }, */
  // 获取喜好列表
  getUserListTags: () => http.get('/tag/frontend/getList'),

  // 删除地址
  delAddress: params => http.get('/user/frontend/account/harvestDel', params),
  // 获取地址列表
  getAddressList: params => http.get('/user/frontend/account/harvests', params),
  // 获取地址详细信息
  getAddress: params => http.get('/user/frontend/account/harvestDetail', params),
  // 保存添加地址
  saveAddress: params => http.post('/user/frontend/account/editHarvest', params),

  // 如家
  // 获取卡券接口
  getCoupons: params => http.get('/external/frontend/user/getCoupons', params),
  // 注册好礼
  rujiaRegister: params => http.post('/external/frontend/user/rujiaRegister', params),

  // 品牌
  // 获取品牌详情
  getBrandDetail: params => http.get('/v3/enterprise/frontend/detail', params),
  // 获取门店列表
  getStoreList: params => http.get('/v3/store/frontend/storeList', params),
  // 获取商品列表
  getProdList: params => http.get('/v3/product/frontend/list', params),

  // 首旅family
  // 获取专属权益产品列表
  getBrandData: (params) => http.get('/v2/user/frontend/getBoutiqueTopicData', params),  
  // 获取专属权益产品列表 app
  getAppBrandData: (params) => http.get('/v2/user/frontend/boutiqueData', params),  
  // 首旅如家弹框
  getRurl: (params) => http.get('/v2/user/frontend/getCode', params), 
  // 首旅如家弹框 app
  getAppRurl: (params) => http.get('/v2/user/frontend/getRurl', params), 
  // 首旅如家高端弹框 app
  getAppHighRurl: (params) => http.get('/v2/user/frontend/getHighUrlForApp', params), 
  // 首旅如家高端弹框
  getHighRurl: (params) => http.get('/v2/user/frontend/getHighUrl', params), 
  // 获取分享用户邀新二维码
  getShareUserQRCode: params => http.get('/v2/user/frontend/getQrcode', params),
  // 更新用户员工状态
  updateUserType: params => http.post('/v2/user/frontend/updateUserInfo', params),
  // 获取员工特权产品
  getExclusiveTopicData: (params) => http.get('/v2/user/frontend/getExclusiveTopicData', params), 
  // 获取员工特权产品 APP
  getAppExclusiveTopicData: (params) => http.get('/v2/user/frontend/exclusiveData', params), 

  // 翻牌
  // 抽奖
  getReward: params => http.get('/marketing/frontend/getReward', params),
  // 统计
  insertStatistics: params => http.get('/marketing/frontend/increStat', params),
  // 获取奖项
  getUserFlops: () => http.get('/marketing/frontend/getUserFlops'),
  // 获取活动规则
  getRules: params => http.get('/marketing/frontend/getAwardRule', params),
  // 好友助力点击
  onFriendHelpClick: params => http.post('/marketing/frontend/friendsHelp', params),

  // 首住
  // 获取门店列表
  getHouseStoreList: params => http.get('/v2/product/frontend/storeList', params),
  // 获取房间详情
  getRoomDetail: params => http.get('/v2/product/frontend/roomDetail', params),
  // 获取日历房信息
  getProductDaysInfo: params => http.get('/v2/pointExchange/frontend/getProductDaysInfo', params),

  // 获取跳转链接
  jumpToThird: params => http.get('/v3/home/frontend/getCode', params),

  // 获取资讯列表
  getNewList: params => http.get('/campaign/frontend/news/list', params),
  // 资讯详情
  getNewsDetail: ( params, id ) => http.get(`/campaign/frontend/news/detail/${id}`, params),
  // 资讯详情推荐模块
  getDYNewsCollection: params => http.mPost('/market/dy/api/dataCollectionToApp', params),
  // 资讯详情商品曝光埋点
  recordProductShowTrack: params => http.mPost('/packageist/dy/api/actionLog/product_show', params),
  // 资讯详情商品点击进入详情埋点
  recordProductClickTrack: params => http.mPost('/packageist/dy/api/actionLog/click_product', params),

  // 一积分
  // 一积分信息
  getIndex: params => http.get('/v2/point/frontend/index', params),
  // 一积分获取banner
  getSetting: params => http.get('/v2/setting/frontend/getSetting', params),
  // 一积分特惠列表
  getPointList: params => http.get('/v2/point/frontend/pointList', params),

  
  // 花积分 
  // 列表
  getPayPointList: params => http.get('/v3/chosen/frontend/pointList', params),
  /* // 获取过期时间与积分
  getOutPointText: params => {
    return http.get('/user/frontend/account/expirePoint', params)
  }, */

  // 精选 
  // 获取banner
  getBanner: params => http.get('/v3/chosen/frontend/banner', params),
  // 获取template
  getTemplate: params => http.get('/v3/chosen/frontend/operationTopic', params),
  // 获取精选列表
  getPickList: params => http.post('/v3/chosen/frontend/communalInquire', params),
  // 根据 吃住行游购娱文 查询 商圈
  getPickTradeArea: params => http.get('/v3/chosen/frontend/tradeArea', params),
  // 根据 吃住行游购娱文 查询 二级分类
  getPickLevelTwo: params => http.get('/v3/chosen/frontend/queryLevelTwo', params),
  // 精选购热门活动资讯
  getPickGouNews: params => http.get('/v3/chosen/frontend/information', params),
  // 精选其他门店推荐
  getPickOtherStore: params => http.get('/v3/store/frontend/storeRecommend', params),
  // 精选住 品牌
  getPickBrandList: () => http.get('/v3/chosen/frontend/enterprise'),
  // 精选住 目的地
  getPickCityList: params => http.get('/v3/chosen/frontend/queryCity', params),
  // 精选文
  getPickWenList: params => http.post('/v2/pointExchange/frontend/getCustomProduct', params),
  // 精选住 品牌推荐
  getZhuBrand: params => http.get('/v3/chosen/frontend/tjEnterprise', params),

  // 套包详情
  getPackageDetail: params => http.get('/v2/package/frontend/detail', params),

  // 获取产品详情规格
  getProductSpec: params => http.get('/v3/product/frontend/getSpecInfo', params),

  // 搜索
  // 获取没有数据的时候精选推荐
  getProductRecommend: params => http.get('/v3/home/frontend/productRecommend', params),
  // 获取搜索产品列表
  getSearchKeyWords: params => http.post('/v3/home/frontend/searchKeywords', params),

  // 专题列表页
  // 获取专题列表商品
  getSubjectProduct: params => http.get('/v2/homepage/frontend/getTopicPage', params),
  // 获取高端商品专题
  getTopProduct: () => http.get('/top/frontend/getList'),

  // 获取热门商圈
  getHotTreadarea: params => http.get('/v3/home/frontend/hotTreadarea', params),
  // 获取所有商圈
  getAllTreadarea: params => http.get('/v3/home/frontend/allTreadarea', params),
  // 商圈特权
  getTradePrivilege: params => http.get('/v3/enterprise/frontend/tradeAreaPrivilege', params),
  // 商圈门店
  getTradeStore: params => http.get('/v3/store/frontend/tradeAreaStore', params),

  // 首页
  // 首页 获取token 跳转悦励
  getUserToken: params => http.get('/v3/home/frontend/userToken', params),
  // 首页 获取弹层
  getHomeLayer: params => http.get('/v3/home/frontend/billing', params),
  // 首页 获取待领取悦励
  getUnGetYueLi: params => http.get('/v3/home/frontend/getUnGetQlNum', params),
  // 首页 获取顶部颜色
  getHomeTopColor: params => http.get('/platformMiniApp/homepage/frontend/color', params),
  // 首页 获取功能模块
  getHomeFunction: params => http.get('/platformMiniApp/homepage/frontend/features', params),
  // 首页 获取板块标题
  getMarketTitle: () => http.get('/v3/home/frontend/marketTitle'),
  // 首页 签到检查
  checkUserSign: params => http.get('/v3/home/frontend/searchSign', params),
  // 首页 用户签到
  userSign: params => http.get('/v3/home/frontend/sign', params),
  // 首页 获取商圈
  getTradearea: params => http.get('/v3/home/frontend/consumeMap', params),
  // 首页 获取商圈产品
  getTradeareaProduct: params => http.get('/v4/frontend/tradeAreaProducts', params),
  // 首页 中部轮播图
  getHomeBanner: params => http.get('/v3/home/frontend/banner', params),
  // 首页 物超所值
  getHomeExcellent: params => http.get('/v3/home/frontend/excellent', params),
  // 首页 品质生活
  getHomeQuality: params => http.get('/v3/home/frontend/quality', params),

  // 门店
  // 门店列表
  getStoreCustomerList: params => http.get('/v3/store/frontend/storeCustomerList', params),
  // 门店详情产品
  getStoreProduct: params => http.get('/v3/store/frontend/product', params),
  // 门店信息
  getStoreDetail: params => http.get('/v3/store/frontend/detail', params),

  // 即时促销
  getSales: params => http.get('/v3/information/frontend/list', params),

  // 我的优惠券列表顶部tab栏接口
  getMyCouponsTabs: params => http.get('/platformMiniApp/marketingCoupon/getUserMarketingStatistics', params),
  // 我的优惠券列表
  getMyCouponsList: params => http.post('/platformMiniApp/marketingCoupon/getUserMarketingList', params),
  // 我的优惠券详情
  getMyCouponDetail: params => http.get('/platformMiniApp/marketingCoupon/couponInfo', params),
  getMyCouponDetailUseRange: params => http.get('/platformMiniApp/marketingCoupon/marketingUseRange', params),
  // 联系导购
  getMyCouponDaogou: params => http.get('/platformMiniApp/marketingCoupon/getQrcode', params),

  // 导购列表
  getGuideList: params => http.post('/v4/frontend/shoppingGuide/guideList', params),
  // 导购品类列表
  getGuideTabList: params => http.get('/v4/frontend/shoppingGuide/tabList', params),
  // 导购列表常用门店
  getGuideLastStore: params => http.get('/v4/frontend/shoppingGuide/lastStore', params),
  // 导购门店列表
  getGuideStoreList: params => http.post('/v4/frontend/shoppingGuide/storeList', params),
  // 导购全部门店列表
  getGuideStoreAllList: params => http.post('/v4/frontend/shoppingGuide/storeAllList?app=3', params),
  // 根据storeId 查询门店详情
  getStoreDetailById: params => http.post('/v4/frontend/shoppingGuide/storeDetail', params),
  // 云逛街列表
  getCloudMallList: params => http.post('/v4/frontend/cloudMall/getCloudMallList', params),
  // 获取导购信息接口
  getGuideInfo: params => http.get('/v4/frontend/shoppingGuide/getGuideInfo', params),

  // 产品详情页 地区是否超区以及物流时效
  verifyAddress: params => http.get('/v4/frontend/logistics/selectExpressInfo', params),
  
  // 2020/5/1 活动
  // 活动规则
  couponActivityRules: params => http.get('/v4/frontend/couponBusiness/couponRules', params),
  // 活动tab
  couponActivityTab: params => http.get('/v4/frontend/couponBusiness/couponTabs', params),
  // 获取非商业卡券列表
  couponActivityPlatformList: params => http.get('/v4/frontend/couponBusiness/couponPlatformLists', params),
  // 获取商业卡券列表
  couponActivitySxfList: params => http.get('/v4/frontend/couponBusiness/couponBusinessLists', params),
  // 领取活动卡券
  getActivityCoupon: params => http.post('/v4/frontend/couponBusiness/getCoupon', params),

  /* H5外部商家聚合页 */
  // 获取商家列表
  getPolymericList: params => http.post('/v4/frontend/partner/polymericList', params),
  // 获取微信sdk
  getJsConfig: params => http.post('/v2/getJsConfig?active=1', params),

  /* 订单确认页 */
  /**
   * 确认订单页面获取领取优惠券
   * @param {Object} params
   * userId - userID
   * productList - 产品列表
   */
  getOrderCouponList: params => http.mPost('/coupon/app/marketingPlatform/oderCoupon/list', params),

  /**
   * 使用优惠券下单支付
   * @param {Object} params
   * orderList - 订单列表
   * orderList.resourceType - 1:产品 2:套包 3:门店 4:线下产品 5:电商商品 6:环球票务
   * totalAmount - 总价
   * activityType - 订单参与活动类型
   * activityId - 订单参与活动ID
   * userMarketingId - 用户营销券ID
   * marketingCouponDeductionMoney - 营销券抵扣金额
   * orderSource - 1:app 2:公众号h5 3:爆品 6:商业首选付 7:动物园小程序 14:平台小程序
   * orderChannel - 分销渠道 1:首客首享 2:京东 3:企业分销 4:个人分销 5:大客户
   */
  createCouponOrder: params => http.post('/v4/frontend/discountArea/createOrder', { ...params, orderSource: '2' }),

  /**
   * 使用优惠券批量支付（已生成订单号）
   * @param {Object} params
   * batchId - 批次号
   * totalAmount - 实际支付价格
   */
  createCouponPay: params => http.post('/v4/frontend/discountArea/pay', {...params, isMiniApp: 0}),

  /**
   * 产品详情获取优惠券列表
   * @param {Object} data
   * productIds - 产品ID
   */
  getProductCouponList: params => http.mPost('/coupon/app/marketingPlatform/productCouponList', params),
  
  /**
   * 领取平台优惠券
   * @param {Object} data
   * userId - 用户id
   * couponSourceType - 领取渠道 3发放 4普通专题 5满减专区
   * marketingId - 优惠券卡包Id
   */
  getPlateCoupon: params => http.mPost('/coupon/app/marketingPlatform/receive/plat/coupon', params),

  /**
   * 平台券可使用产品列表
   * @param {Object} data
   * marketingId - 平台券ID（卡包id）
   */
  getPlateCouponProds: params => http.mPost('/coupon/app/marketingPlatform/find/product/list', params),

  /**
   * 环球门店营销首页
   * @param {Object} params
   * storeId - 门店id
   */
  getUbrTheme: params => http.mPost('/market/thirdparty/enterpriseMarketingTmp/getMarketingInfo', params),

  /**
   * ubr产品详情 下单初始化
   * productId - ubr产品id
   */
  ubrProductDetail: params => http.mPost('/product/ubr/product/ticket/init', params),

  /**
   * ubr 票类型字典
   * @param {Object} params
   *  type - 'UBR_TICKET_CATEGORY'
   *  */ 
  queryDicMapByType: params => http.mGet(`/packageist/app/dic/queryDicMapByType/${params.type}`),

  /**
   * 获取UBR票务订单设置的入园游客上限数
   */
  getUbrOrderNumberLimit: () => http.mGet(`/order/ubr/notification/getOrderNumberLimit`),

  /**
   * UBR开票时间
   * @param {Object} params
   * reserveTerminal - 预约终端(0:小程序 1:安卓 2:IOS)
   */
  ubrReserveUpdate: params => http.jPost('ubr/reserve/update', params),

  /**
   * 检查用户是否已经预约
   */
  ubrReserveCheckUser: params => http.jPost('ubr/reserve/checkUser', params),

  /**
   * 外部小程序内嵌h5 传入手机号登录
   * mobile - 加密后的手机号
   * storeId - 门店id
   * source - 来源小程序，如：nuojin
   */
  miniapph5login: params => http.post('/ubrWxWap/login', params),

  /** 
   * 获取验证码 
   * @param {Object} params
   *  body - 使用公钥 rsa 加密后的值
   * */ 
  getMobileCode: params => http.mPost('/frontend/mobile/code/send', params),

  /** 
   * 验证手机号验证码
   * @param {Object} params
   *  body - 使用公钥 rsa 加密后的值
   * */ 
  verifyMobileCode: params => http.mPost('/frontend/mobile/code/verify', params),

  /*
   * 支付成功页-轮播图
   * modulePosition - 营销位位置 固定:6008160
   * deploy - 配置业务 1.首客首享 2.综合首选付 3.商业首选付 4.环球票 5.环球酒店 6环球打包 7.首客首享打包
   * orderBy - 排序字段 固定:  pos
   * cityCode - 城市编码
   */
  getMarketPosBanner: params => http.mPost('/market/app/marketPosBanner/read/list', params),

  /**
   * 支付成功页-精品推荐
   * modulePosition - 营销位位置 固定:6008160
   * deploy - 配置业务 1.首客首享 2.综合首选付 3.商业首选付 4.环球票 5.环球酒店 6环球打包 7.首客首享打包
   * orderBy - 排序字段 固定:  pos
   * cityCode - 城市编码
   */
  getMarketPayedProduct: params => http.mPost('/market/app/marketPayedProduct/guessYouLike', params),

  /**
   * 我的行程列表
   */
   getTripSummaryList: params => http.mPost('/order/app/order/query/tripSummary', params),

  /**
   * ubr和首客首享
   */
   getUbrSksxPackage: params => http.mPost('/market/app/subject/ubr/package', params),

  /**
   * urb专题推荐
   * subjectId- id
   * pageNum
   * pageSize
   */
   getSubjectRecommendProduct: params => http.mPost('/product/subject/recommend/product', params),

  /**
   * 新秒杀专题接口
   */
  getSeckillSubjectInfo: params => http.mPost(`/market/subject/read/seckill/${params}`),

  /**
   * 查询时间段内的优惠券和商品
   */
  getSeckillTimeData: params => http.mPost('/market/subject/read/seckillData', params),

  /**
   * 查询时间段内的优惠券
   */
  getSeckillCouponList: id => http.mGet(`/market/subject/read/seckill/coupon/list/${id}`),

  /**
   * 查询时间段内的产品列表
   */
  getSeckillProductList: params => http.mPost('/market/subject/read/seckill/product/page', params),

  /**
   * 获取普通专题产品列表，有分页
   */
  getCommonSubjectProducts: params => http.mPost('/product/searchProduct', params),

  /**
   * 获取family ubr票列表
   */
  getUbrSubjectProducts: params => http.mGet('/product/subject/query/ubr/productList', params),

  /**
   * 获取是否到达family买票上限
   */
  checkFamilyUbrStatus: () => http.mGet('/order/query/checkFamilyUbrStatus'),

  /**
   * 用户注销
   * @param {Object}
   * @property {String} mobile - 手机号
   */
  setUserLogout: params => http.mPost('/user/api/setUserAttribute', params),

  /**
   * 获取普通专题详情
   */
  getAppSubject: (params) => http.mGet(`/packageist/subject/read/detail/${params}`),

  /**
   * 获取专题通用产品列表
   * @param {Object}
   * @property {String} subjectId - 专题id
   * @property {String} pageSize
   * @property {String} pageNum
   * @property {String} channelType - 渠道号 app固定传1
   */
  searchProduct: (params) => http.mPost('/market/subject/searchProduct', params),

  /**
   * 周末精选的商品瀑布流接口
   * @param {Object}
   * @property {String} homeType - 主题类型，从首页数据接口获取
   * @property {String} mkHomeId - 首页数据的id
   * @property {String} mkHomeModelId - 模板层的id
   * @property {String} pageSize
   * @property {String} pageNum
   * @property {String} channelType - 渠道号 app固定传1
   */
   recommendedProduct: (params) => http.mPost('/market/recommended/products', params),
  
  /**
   * 猫眼 - 获取演出项目下的场次区域信息
   * @param {Object}
   * @property {String} performanceId - 项目ID
   * @property {String} showId - 场次ID
   */
  getPerformanceAreaInfo: (params) => http.mPost('/product/performance/getOpenShow', params),

  /**
   * 猫眼 - 获取场次下票档列表
   */
   getTicketUnitDetail: showId => http.mGet(`/product/performance/getTicketunitList/${showId}`),

  /**
   * 猫眼 - 获取所选区域座位信息
   * @param {Object}
   * @property {String} showId - 场次ID
   * @property {String} areaId - 所选区域ID
   */
   getSelectAreaSeats: params => http.mPost('/product/performance/getMaoyanSeates', params),

  /**
   * 猫眼 - 新接口获取所选座位信息
   * @param {Object}
   * @property {String} showId - 场次ID
   */
  getSeatChart: params => http.mPost('/product/app/performance/getSeatChart', params),

  /**
   * 猫眼 - 新接口获取所选座位信息
   * @param {Object}
   * @property {String} showId - 场次ID
   */
  getSeatStatus: params => http.mPost('/product/app/performance/getSeatStatus', params),

  /**
   * 热点营销 - 获取整体数据信息 
   * @param {Object}
   * @property {String} homeId - 营销ID
   * @property {String} channelType - 渠道类型：1-首客首享，2-京东 3-企业分销 4-个人分销 5-大客户 6-如家 7-飞猪 10-企业二级分销 11-VIP 12-抖音 13-百度 14-首旅family 15-去哪儿
   */
  getHotTopicsInfo: (params) => http.mPost('/market/marketing/page/detail', params),
  /**
   * 热点营销 - 瀑布流数据 
   * @param {Object}
   * @property {String} pageNum - 请求页数
   * @property {String} pageSize - 请求页大小，默认是10
   * @property {String} mkHomeClassifyId - 营销ID
   * @property {String} channelType - 渠道类型：1-首客首享，2-京东 3-企业分销 4-个人分销 5-大客户 6-如家 7-飞猪 10-企业二级分销 11-VIP 12-抖音 13-百度 14-首旅family 15-去哪儿
   */
   productsPage: (params) => http.mPost('/market/marketing/page/products/page', params),
   /**
    * 获取优惠券具体信息
   */
  getCouponCont: (showId) => http.mGet(`/coupon/app/small/marketing/bathMarketingInfoByIds/${showId}`),

  /**
   * 招募活动专题页 - 达人基础信息收集
   * @param {Object}
   * @property {String} cellPhone - 手机号
   * @property {String} expertName - 达人姓名
   * @property {String} wechatNumber - 微信号
   */
  addExpertInfo: (params) => http.mPost('/user/app/expert/add/info', params),
};